// export const API_URL = 'https://ftmo-api-dev.buso.asia/';
export const is_dev = false;
export const is_local = false;

export const API_URL_DEV = 'https://ftmo-api-dev.buso.asia/';
export const API_URL_PROD = 'https://ftmo-real-api.buso.asia/';
export const API_URL_LOCAL = 'http://192.168.1.103:8002/';


export const API_URL = is_local ? API_URL_LOCAL : (is_dev ? API_URL_DEV : API_URL_PROD);
//export const API_URL = 'https://lumir-api-dev.wealthfarming.org/'
// export const API_URL = 'https://lumir-api.wealthfarming.org/'
// export const API_URL = 'https://ftmo-real-api.buso.asia/';
export const API_URL_v2 = '';
export const API_URL_IMAGE = '';
export const KEY_TINY = 'tbqivyzggr2y8zzl8ca0qm0xv6aedzd50r1wmixv7an3mh2l'
